// ce fichier est la pour forcer le chargement de la traduction en anglais
export const messages = {
    "{locale} (auto)": "{locale} (auto)"
}